/* FB | Mobil ust yukleme cubugu (additive, 2026-06-10). Linke tiklaninca sayfa 150ms icinde
   acilmazsa ustte ince turuncu ilerleme cubugu gosterir; sayfa degisince tamamlanip kaybolur.
   Prerender'li (aninda acilan) sayfalarda hic gorunmez. Sadece mobil (<750px).
   Hicbir tema davranisini degistirmez; yalniz gorsel geri bildirim ekler.
   Kaldirmak icin: theme.liquid'deki fb-nav-progress.js script satirini sil. */
(function(){
  'use strict';
  if(window.__fbNavBar) return; window.__fbNavBar=true;
  if(window.innerWidth >= 750) return;

  var bar=null, grow=null, pending=null, safety=null;

  function ensure(){
    if(bar) return;
    var s=document.createElement('style');
    s.id='fb-nav-progress-style';
    s.textContent='#fb-nav-progress{position:fixed;top:0;left:0;height:3px;width:0;background:var(--fb-cart-secondary-color,#da5e2d);z-index:2147483647;pointer-events:none;opacity:0;transition:width .25s ease,opacity .25s ease;}';
    document.head.appendChild(s);
    bar=document.createElement('div');
    bar.id='fb-nav-progress';
    document.body.appendChild(bar);
  }
  function show(){
    ensure();
    var w=12;
    bar.style.opacity='1';
    bar.style.width=w+'%';
    grow=setInterval(function(){ w=Math.min(w+(92-w)*0.12, 92); bar.style.width=w+'%'; }, 180);
    safety=setTimeout(hide, 8000); /* guvenlik: navigasyon gerceklesmezse kendini temizler */
  }
  function hide(){
    if(pending){clearTimeout(pending);pending=null;}
    if(grow){clearInterval(grow);grow=null;}
    if(safety){clearTimeout(safety);safety=null;}
    if(bar){ bar.style.width='100%'; setTimeout(function(){ if(bar){ bar.style.opacity='0'; bar.style.width='0'; } }, 180); }
  }

  document.addEventListener('click', function(e){
    if(e.defaultPrevented) return;
    var a=(e.target&&e.target.closest)?e.target.closest('a[href]'):null;
    if(!a) return;
    if(a.target && a.target!=='_self') return;
    if(a.hostname!==location.hostname) return;
    var h=a.getAttribute('href')||'';
    if(!h || h.charAt(0)==='#') return;
    if(/^(javascript:|mailto:|tel:)/.test(h)) return;
    if(pending) clearTimeout(pending);
    /* FB (2026-06-11): /account, /cart, /checkout HIC prerender edilmez (fb-speed bilerek haric tutar)
       -> bu linklerde cubugu BEKLEMEDEN goster ("gec aciliyor" hissini aninda geri bildirimle kapat).
       Digerlerinde 150ms bekle: prerender ile ANINDA acilan sayfada cubuk hic gorunmez. */
    if(/\/(account|cart|checkout)|logout/.test(h)){ show(); }
    else { pending=setTimeout(show, 150); }
  }, {passive:true});

  window.addEventListener('pagehide', hide);
  window.addEventListener('pageshow', hide);
})();
